/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptions } from './FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptions';
import {
    instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptions,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptionsFromJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptionsFromJSONTyped,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptionsToJSON,
} from './FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptions';

/**
 * @type FxIdApplicationPublicDataBuilderPlatformDataOptionsSteam
 * 
 * @export
 */
export type FxIdApplicationPublicDataBuilderPlatformDataOptionsSteam = FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptions;

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamFromJSON(json: any): FxIdApplicationPublicDataBuilderPlatformDataOptionsSteam {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderPlatformDataOptionsSteam {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptions(json)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamToJSON(json: any): any {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamToJSONTyped(value?: FxIdApplicationPublicDataBuilderPlatformDataOptionsSteam | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptions(value)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptionsToJSON(value as FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptions);
    }

    return {};
}

